
namespace TabAurous.SalesOrder {

    @Serenity.Decorators.registerClass()
    export class SalesOrderItemsDialog extends _Ext.ItemEditorDialog<SalesOrderItemsRow> {
        protected getFormKey() { return SalesOrderItemsForm.formKey; }
        protected getLocalTextPrefix() { return SalesOrderItemsRow.localTextPrefix; }

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        public form = new SalesOrderItemsForm(this.idPrefix);

        // #region Public Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public Closing: boolean;
        public ItemMaster: any;
        public LotNo: any;
        // #endregion 

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);
            q.hideCategorylinks(this.element);
            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.



            // #region Field Change Events

            this.form.Pieces.changeSelect2(e => {
                if (this.form.HasBom.value)
                    this.CalculateTotals();
                else
                    this.CalculateRate();
            });

            // **** On Pieces Change Event **** 
            this.form.Weight.changeSelect2(e => {
                if (!isNaN(this.form.Weight.value)) {

                    var lbr = this.form.LaborDetails.getItems();
                    var self = this;
                    lbr.forEach(function (x) {
                        x.Weight = self.form.Weight.value;
                        x.Pieces = self.form.Pieces.value;
                        x.LabourAmount = x.CalcOnId == 61 ? self.form.Pieces.value * x.LabourRate : self.form.Weight.value * x.LabourRate;

                    });

                    this.form.LaborDetails.setItems(lbr);
                    this.CalculateRate();
                }

            });

            this.form.UnitRate.changeSelect2(e => {
                if (this.form.UnitRate.value != null)
                    this.CalculateRate();
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.CalcOnId.value != "")
                    this.CalculateRate();
            });

            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.entity.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
                    var VoucherDetails = Q.first(OMS.VoucherMasterRow.getLookup().items, x => x.VoucherTypeId == this.ItemMaster.form.VoucherTypeId.value);

                    switch (this.form.ItemTypeId.value) {
                        case 101:
                            this.form.DepartmentId.value = VoucherDetails.DefaultJewelleryDepartment;
                            break;
                        case 104:
                            this.form.DepartmentId.value = VoucherDetails.DefaultMetalDepartment;
                            break;
                        case 105:
                            this.form.DepartmentId.value = VoucherDetails.DefaultStoneDepartment;
                            break;
                    }
                }
            });

            this.form.UnitLabour.changeSelect2(e => {
                if (this.form.UnitLabour.value != null) {
                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;
                    if (this.form.Pieces.value != null) {
                        this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                    }
                    //this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                    //this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
                }
            });

            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });

            this.form.SubCategoryId.changeSelect2(e => {
                if (this.form.SubCategoryId.value != "")
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            });
            this.form.HasBom.changeSelect2(e => {
                var self = this;
                if (this.form.BOMDetails.getItems().length > 0) {
                    q.information(q.text("Message.Voucher.ReadOnly", "Are you sure?"), q.text("Message.Voucher.ReadOnlyInfo", "This will remove all components"), true, function () {
                        self.removeBOM();
                        ItemFieldHelper.PurchaseItemFields(self, self.ItemMaster.form.VoucherTypeId.value);
                    }, function () {
                        self.form.HasBom.value = true;
                    });
                } else
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            });
            this.form.KaratId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.KaratId.value)) {

                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    var min = purity.MinPurity;
                    var max = purity.MaxPurity;
                    var std = purity.StdPurity;
                    q.showAndSetRequiredField(this.form.Purity);
                    this.form.Purity.value = std;
                    this.form.Purity.value = std;
                    var date = new Date((this.parentEditor.parentDialog as SalesOrderDialog).form.TransDate.value);
                    this.form.UnitRate.value = RateHelper.GetMetalRate(parseInt(this.form.MetalId.value), parseInt(this.form.KaratId.value), false, date) / this.ExchangeRate;
                }

            });

            this.form.MetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.MetalId.value)) {
                    q.showAndSetRequiredField(this.form.KaratId);
                    this.form.KaratId.cascadeField = "Num1";
                    this.form.KaratId.cascadeValue = this.form.MetalId.value;
                }
            })

            this.form.Purity.change(e => {
                if (this.form.Purity.value != null) {
                    var current = this.form.Purity.value;
                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    var min = purity.MinPurity;
                    var max = purity.MaxPurity;
                    var std = purity.StdPurity;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min + "  to  " + max);
                        this.form.Purity.value = this.form.Purity.value;
                    }
                    this.CalculateRate();
                }
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.ShapeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.SieveId.changeSelect2(e => {
                var sievegroupid = OMS.AttributeMasterRow.getLookup().itemById[this.form.SieveId.value].GroupSieveId;
                this.form.GroupSieveId.value = sievegroupid.toString();
                this.GetRate();
            });

            this.form.QualityId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.StoneColorId.changeSelect2(e => {
                this.GetRate();
            });

            // #endregion

            //*** BOM row add Edit Delete Event ****

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            this.form.StoneRate.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

            this.form.StoneWeight.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });
            var fieldEditor: JQuery = this.form.DesignCode.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }
        protected inplaceSearchClick(e: any): void {
            if (!this.isViewMode()) {

                var grid = OMS.DesignGrid;

                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select Design"
                });

                pickerDialog.onSuccess = (selectedItems: OMS.DesignRow[]) => {

                    if (selectedItems.length > 0) {

                        this.form.DesignId.value = selectedItems[0].DesignId.toString();
                        this.form.DesignCode.value = selectedItems[0].DesignCode;

                    }
                }
                pickerDialog.dialogOpen();

            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }

        removeBOM() {
            var item = [];
            this.form.BOMDetails.view.setItems(item, true);
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.ItemMaster = (this.parentEditor.parentDialog as SalesOrderDialog);
            this.RateListId = this.ItemMaster.RateListId;
            this.LaborListId = this.ItemMaster.LaborListId;
            this.StoneMarkup = this.ItemMaster.StoneMarkup;
            this.StoneDiscount = this.ItemMaster.StoneDisount;
            this.ExchangeRate = this.ItemMaster.ExchangeRate;
            this.TransDate = this.ItemMaster.form.TransDate.valueAsDate
            //this.Setfields();

            if (this.form.ProductTypeId.value == "") {
                this.form.ProductTypeId.items = this.form.ProductTypeId.items.filter(x => x.id != "5" && x.id != "6" && x.id != "7");
            }
            ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
        }


        getItem() {
            return this.getSaveEntity();
        }

        protected validateBeforeSave() {
            var IsValid = true;
            this.form.AttributeId.value = "0";
            var t = this.RateListId;
            this.entity.RefTransId == null ? this.entity.RefTransId = 0 : this.entity.RefTransId = this.entity.RefTransId
            this.entity.RefTransItemId == null ? this.entity.RefTransItemId = 0 : this.entity.RefTransItemId = this.entity.RefTransItemId
            this.entity.RefVoucherId == null ? this.entity.RefVoucherId = 0 : this.entity.RefVoucherId = this.entity.RefVoucherId
            this.entity.Studded == null ? this.entity.Studded = 0 : this.entity.Studded = this.entity.Studded
            this.entity.MetalAmount == null ? this.entity.MetalAmount = 0 : this.entity.MetalAmount = this.entity.MetalAmount
            this.entity.DiamondAmount == null ? this.entity.DiamondAmount = 0 : this.entity.DiamondAmount = this.entity.DiamondAmount
            this.entity.StoneAmount == null ? this.entity.StoneAmount = 0 : this.entity.StoneAmount = this.entity.StoneAmount

            if (this.form.ItemTypeId.value == 101) {

                if (this.form.HasBom.value) {
                    let items = this.form.BOMDetails.getItems();
                    let count = 0;
                    if (items.length > 0) {

                        items.forEach(function (x) {
                            if (x.ItemTypeId == 104)
                                count++
                        });

                        if (count == 0) {
                            q.Warning("Can not Save!", "Metal details not defined", false);
                            IsValid = false;
                        }
                        else
                            IsValid = true;
                    }
                    else {
                        q.Warning("Can not Save!", "Components or BOM is not defined", false);
                        IsValid = false;

                    }
                } 
                var value = q.ToBool(TabAurous.GetConfigValue(1004));
                if (value == true && Q.isEmptyOrNull(this.form.SKU.value)) {
                    var SKU = FormatHelper.GetFormats("SKU");
                    this.form.SKU.value = SKU;
                    this.entity.Studded = 1;
                }
                if (Q.isEmptyOrNull(this.form.Line_No.value)) {
                    Purchase.PurchaseMasterService.GetLineNo({}, response => this.form.Line_No.value = response.Line_No.toString(), {
                        async: false
                    });
                }


            }
            else {
                this.entity.Studded = 1;
            }

            if (this.form.Weight.value == 0) {
                q.Warning("Can not Save!", "Weight is undefined or 0", false);
                IsValid = false;
            }
            else {
                IsValid = true;
            }

            return IsValid;

        }
    }
}